import type { ComponentType, ReactNode, SVGProps } from "react";

/** A lucide-react icon (or any component that takes the same props). */
export type KitIcon = ComponentType<SVGProps<SVGSVGElement> & { size?: number | string; strokeWidth?: number | string; absoluteStrokeWidth?: boolean }>;

/**
 * The tint behind an icon. Seal = the brand mark (replies, things Ogma did), ochre = waiting on you, moss = done,
 * neutral = everything else. All four follow the theme tokens, so dark mode and white-labelling just work.
 */
export type IconTone = "seal" | "ochre" | "moss" | "neutral";

/**
 * IconTile: a 30–40px rounded square, tinted, holding one 1.75px-stroke line icon. Decorative (aria-hidden): the
 * words next to it carry the meaning. `size` sm = 30px (stat tiles), md = 38px (list rows), lg = 40px (fold cards).
 */
export function IconTile({ icon: Icon, tone = "neutral", size = "md", outline = false, children }: { icon?: KitIcon; tone?: IconTone; size?: "sm" | "md" | "lg"; outline?: boolean; children?: ReactNode }) {
  const px = size === "sm" ? 16 : size === "md" ? 18 : 20;
  return (
    <span className={`icon-tile icon-tile-${size} tone-${tone}${outline ? " icon-tile-outline" : ""}`} aria-hidden="true">
      {Icon ? <Icon size={px} strokeWidth={1.75} aria-hidden="true" focusable="false" /> : children}
    </span>
  );
}
